import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import React from 'react';
import TabButton from '@dashboard/components/TabButton';

export default function CheckoutShareWebsite({ tabs }) {
  return (
    <TabGroup>
      <TabList className="flex gap-2">
        {tabs.map(({ name, key }) => (
          <Tab key={key} className="w-full font-semibold ">
            {({ selected }) => <TabButton selected={selected}>{name}</TabButton>}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {tabs.map(({ key, content }) => (
          <TabPanel key={key} className="">
            {content}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
}
